<template>
  <div class="box box-primary">
    <div class="box-header">
      <h3 class="box-title">
        {{ $t("configuration.apartmentTypePrice.title") }}
      </h3>
    </div>
    <div class="box-body">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group required">
                  <label class="control-label required" for="">{{
                    $t("apartmentType.title")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="apartmentTypeName"
                    disabled
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label" for="">{{
                    $t("configuration.apartmentTypePrice.priceType")
                  }}</label>
                  <select
                    v-model="aparmentTypePriceData.priceType"
                    class="form-control"
                  >
                    <option
                      v-for="priceType in apartmentTypePriceTypeList"
                      v-bind:value="priceType.value"
                      :key="priceType.value"
                      >{{ $t(priceType.text) }}</option
                    >
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group required">
                  <label class="control-label required" for="">{{
                    $t("configuration.apartmentTypePrice.priceName")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="aparmentTypePriceData.priceName"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group required">
                  <label class="control-label required" for="">{{
                    $t("configuration.apartmentTypePrice.dayUnitPrice")
                  }}</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model="aparmentTypePriceData.dayUnitPrice"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label class="control-label" for="">{{
                    $t("apartmentType.adults")
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="aparmentTypePriceData.priceForExtraPerson"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-8">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="">
                            {{
                              $t(
                                "configuration.apartmentTypePrice.earlyCheckInAuxiliary"
                              )
                            }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">{{ $t("common.nonumber") }}</th>
                                <th scope="col">
                                  {{
                                    $t(
                                      "configuration.apartmentTypePrice.installationDate"
                                    )
                                  }}
                                </th>
                                <th scope="col">
                                  {{
                                    $t(
                                      "configuration.apartmentTypePrice.unitPrice"
                                    )
                                  }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <th scope="row">1</th>
                                <td>Mark</td>
                                <td>Otto</td>
                              </tr>
                              <tr>
                                <th scope="row">2</th>
                                <td>Jacob</td>
                                <td>Thornton</td>
                              </tr>
                              <tr>
                                <th scope="row">3</th>
                                <td>Larry</td>
                                <td>the Bird</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="">
                            {{
                              $t(
                                "configuration.apartmentTypePrice.lateCheckOutAuxiliary"
                              )
                            }}
                          </label>
                        </div>
                      </div>
                      <div class="col-md-12">
                        <div class="form-group">
                          <table class="table">
                            <thead>
                              <tr>
                                <th scope="col">{{ $t("common.nonumber") }}</th>
                                <th scope="col">
                                  {{
                                    $t(
                                      "configuration.apartmentTypePrice.installationDate"
                                    )
                                  }}
                                </th>
                                <th scope="col">
                                  {{
                                    $t(
                                      "configuration.apartmentTypePrice.unitPrice"
                                    )
                                  }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <th scope="row">1</th>
                                <td>Mark</td>
                                <td>Otto</td>
                              </tr>
                              <tr>
                                <th scope="row">2</th>
                                <td>Jacob</td>
                                <td>Thornton</td>
                              </tr>
                              <tr>
                                <th scope="row">3</th>
                                <td>Larry</td>
                                <td>the Bird</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="box-footer">
      <button
        type="button"
        class="btn btn-labeled btn-danger"
        style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
        @click="onCallBack($event)"
      >
        <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
        {{ $t("common.back") }}
      </button>
      <button
        type="button"
        class="btn btn-labeled btn-success pull-right"
        style="margin-right: 5px;"
        @click="onSave"
      >
        <span class="btn-label">
          <i class="glyphicon glyphicon-ok"></i>
        </span>
        {{ $t("common.save") }}
      </button>
    </div>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";

import constantsData from "@/lib/constantsData";
import utils from "@/lib/utils";

export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading
  },
  data: () => ({
    isLoading: false,
    apartmentTypePriceTypeList: constantsData.apartmentTypePriceTypeList,
    aparmentTypePriceData: {
      id: 0,
      apartmentTypeId: null,
      priceType: 1,
      priceName: null,
      dayUnitPrice: null,
      priceForExtraPerson: null,
      discount: null
    },
    apartmentTypeName: ""
  }),
  watch: {
    GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA;
      let index = data.findIndex(
        x => (x.id = this.aparmentTypePriceData.apartmentTypeId)
      );
      this.apartmentTypeName = index !== -1 ? data[index].name : null;
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_APARTMENT_TYPE_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    onCallBack: function() {
      window.history.back();
    },
    onShowError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    getApartmentTypeList: function() {
      this.isLoading = true;
      this.GET_APARTMENT_TYPE_LIST()
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    onSave: function() {
      if (utils.isEmptyString(this.aparmentTypePriceData.priceName)) {
        this.onShowError(this.$t("configuration.apartmentTypePrice.priceName"));
      } else if (utils.isEmptyString(this.aparmentTypePriceData.dayUnitPrice)) {
        this.onShowError(this.$t("configuration.apartmentTypePrice.dayUnitPrice"));
      } else {
        let data = {
          id: this.aparmentTypePriceData.id,
          apartmentTypeId: this.aparmentTypePriceData.apartmentTypeId,
          priceType: this.aparmentTypePriceData.priceType,
          priceName: this.aparmentTypePriceData.priceName,
          dayUnitPrice: this.aparmentTypePriceData.dayUnitPrice,
          priceForExtraPerson: this.aparmentTypePriceData.priceForExtraPerson,
          discount: this.aparmentTypePriceData.discount
        };
        this.isLoading = true;
        if (this.aparmentTypePriceData.id === 0) {
          this.CREATE_APARTMENT_TYPE_PRICE(data)
            .then(
              function() {
                this.onCallBack();
                this.isLoading = false;
              }.bind(this)
            )
            .catch(
              function() {
                this.isLoading = false;
              }.bind(this)
            );
        } else {
          this.UPDATE_APARTMENT_TYPE_PRICE(data)
            .then(
              function() {
                this.onCallBack();
                this.isLoading = false;
              }.bind(this)
            )
            .catch(
              function() {
                this.isLoading = false;
              }.bind(this)
            );
        }
      }
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_APARTMENT_TYPE_LIST",
      "CREATE_APARTMENT_TYPE_PRICE",
      "UPDATE_APARTMENT_TYPE_PRICE",
      "GET_APARTMENT_TYPE_PRICE_DETAIL"
    ])
  },
  mounted() {
    let apartmentTypeId = this.$route.params.apartmentTypeId;
    this.aparmentTypePriceData.apartmentTypeId = apartmentTypeId;
    this.getApartmentTypeList();
    let id = this.$route.params.id;
    if (id !== 0) {
      this.GET_APARTMENT_TYPE_PRICE_DETAIL({ id: id }).then(
          function(res) {
            this.aparmentTypePriceData.id = res.id;
            this.aparmentTypePriceData.priceType = res.price_type;
            this.aparmentTypePriceData.priceName = res.price_name;
            this.aparmentTypePriceData.dayUnitPrice = res.day_unit_price;
            this.aparmentTypePriceData.priceForExtraPerson =
              res.price_for_extra_person;
            this.aparmentTypePriceData.discount = res.discount;
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    }
  }
};
</script>
<style scoped>
label.required:after {
  content: " *";
  color: red;
  position: absolute;
  padding-left: 8px;
  top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Configuration/ApartmentType/ApartmentTypePriceAdd.vue